<template>
  <a-form-model
    ref="editReportForm"
    :form="form"
    :model="form"
    @submit="handleSubmit"
    @submit.native.prevent
  >
    <div class="w-full flex">
      <a-form-model-item
        :label="'Share value (' + form.shareValueCurrency + ')'"
        class="mr-4 flex-1"
        prop="shareValue"
      >
        <a-input-number v-model="form.shareValue" class="w-full" />
      </a-form-model-item>
      <a-form-model-item
        :label="'Dividend (' + form.dividendCurrency + ')'"
        class="flex-1"
        prop="dividend"
      >
        <a-input-number v-model="form.dividend" class="w-full" />
      </a-form-model-item>
    </div>

    <a-button type="primary" html-type="submit" :disabled="isSaving">
      Save
    </a-button>
    <a-button class="ml-4" @click="onCancelButtonClicked()">
      Cancel
    </a-button>
  </a-form-model>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  apollo: {
    fiMonthlyReport: {
      query: gql`
        query GetFIMonthlyReport(
          $institutionId: Uuid!
          $year: Int!
          $month: Int!
        ) {
          fiMonthlyReport(
            institutionId: $institutionId
            year: $year
            month: $month
          ) {
            institution {
              currency
            }
            shareValue {
              amount
              currency
            }
            dividend {
              amount
              currency
            }
          }
        }
      `,
      variables() {
        return {
          institutionId: this.report.institutionId,
          year: this.report.year,
          month: this.report.month,
        }
      },
      update(data) {
        this.form = {
          shareValue: data.fiMonthlyReport.shareValue.amount,
          shareValueCurrency: data.fiMonthlyReport.shareValue.currency,
          dividend: data.fiMonthlyReport.dividend
            ? data.fiMonthlyReport.dividend.amount
            : null,
          dividendCurrency: data.fiMonthlyReport.dividend
            ? data.fiMonthlyReport.dividend.currency
            : data.fiMonthlyReport.institution.currency,
        }
      },
    },
  },
  data() {
    return {
      form: {
        shareValue: null,
        shareValueCurrency: null,
        dividend: null,
        dividendCurrency: null,
      },
      isSaving: false,
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.editReportForm.validate(async (valid) => {
        if (valid) {
          try {
            this.isSaving = true
            await this.$apollo.mutate({
              mutation: gql`
                mutation($input: UpdateFIMonthlyReportInput) {
                  updateFIMonthlyReport(input: $input) {
                    reportId
                  }
                }
              `,
              variables: {
                input: {
                  institutionId: this.report.institutionId,
                  year: this.report.year,
                  month: this.report.month,
                  shareValue: this.form.shareValue,
                  dividend: this.form.dividend,
                },
              },
            })
            this.isSaving = false
            this.$refs.editReportForm.resetFields()
            this.$emit('reportSaved', {
              year: this.form.year,
              month: this.form.month,
            })
          } catch (error) {
            this.$message.error(error.message)
            this.isSaving = false
          }
        } else {
          return false
        }
      })
    },
    onCancelButtonClicked() {
      this.$emit('cancelButtonClicked')
      this.$refs.addReportForm.resetFields()
    },
  },
}
</script>

<style></style>
